import Button from '@material-ui/core/Button';
import MoneyIcon from '@material-ui/icons/AttachMoney';
import PlayArrow from '@material-ui/icons/PlayArrow';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	textFieldStyle: {
		width: '80px',
		textAlign: 'center',

		[theme.breakpoints.down('xs')]: {
			width: '70px',
		},
	},
	playButton: {
		backgroundColor: theme.palette.common.white,
		height: '36px',
		width: '40px',
		minWidth: '40px',
		padding: '0px',
	},
	priceField: {
		// allows the price filter to not overflow
		minWidth: 320,
		marginLeft: -6,
	},
});

const PriceFilter = props => {
	const { classes } = props;
	return (
		<div>
			<form
				onSubmit={event => {
					event.preventDefault();
					props.handlePriceFilterApply();
				}}
			>
				<div className={classes.priceField}>
					<span>
						<MoneyIcon style={{ position: 'relative', top: '8px' }} />
					</span>
					<span style={{ paddingRight: '10px' }}>
						<TextField
							placeholder="Min"
							onChange={event => props.handleMinPriceTextChange(event.target.value)}
							value={props.minPriceText}
							inputProps={{ className: classes.textFieldStyle, maxLength: 9 }}
						/>
					</span>
					<span>to</span>
					<span style={{ padding: '0 10px' }}>
						<TextField
							placeholder="Max"
							onChange={event => props.handleMaxPriceTextChange(event.target.value)}
							value={props.maxPriceText}
							inputProps={{ className: classes.textFieldStyle, maxLength: 9 }}
						/>
					</span>
					<span>
						<Button type="submit" variant="contained" className={classes.playButton}>
							<PlayArrow style={{ height: '30px', width: '30px' }} />
						</Button>
					</span>
				</div>
			</form>
			{props.priceError.length > 0 ? (
				<div style={{ paddingTop: '5px', paddingBottom: '10px', fontWeight: 'bold' }}>
					{props.priceError}
				</div>
			) : null}
		</div>
	);
};

PriceFilter.propTypes = {
	handleMaxPriceTextChange: PropTypes.func.isRequired,
	handleMinPriceTextChange: PropTypes.func.isRequired,
	handlePriceFilterApply: PropTypes.func.isRequired,
	maxPriceText: PropTypes.string.isRequired,
	minPriceText: PropTypes.string.isRequired,
	priceError: PropTypes.string,
	classes: PropTypes.shape({
		textFieldStyle: PropTypes.string,
		playButton: PropTypes.string,
		priceFilter: PropTypes.string,
	}).isRequired,
};

PriceFilter.defaultProps = {
	priceError: '',
};

export default withStyles(styles, { name: 'PriceFilter' })(PriceFilter);
